import { vysionTrack } from './vysionService';

const setCartAbandonVysion = (param: any): void => {
  switch (param.event) {
    case 'DEACTIVATE':
      vysionTrack(param, 'account-deactivation');
      break;
    case 'GDPR_DELETE':
      vysionTrack(param, 'account-gdpr-delete');
      break;
    default:
      return;
  }
};

export { setCartAbandonVysion };
